/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Chain_To_Next_EventInputs */

const en_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap the Event outcode to the next Event's incode`)
};

const fr_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accrocher l'outcode de l'evenement a l'incode de l'evenement suivant`)
};

const de_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordne den Ausgabecode des Ereignisses dem Eingabecode des nächsten Ereignisses zu.`)
};

const it_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega l'outcode dell'evento all'incode dell'evento successivo`)
};

const ru_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сопоставьте исходящий код события с входящим кодом следующего события.`)
};

const es_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar el código de salida del evento al código de entrada del siguiente evento`)
};

const zh_cn2_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件的输出代码与下一个事件的输入代码对齐。`)
};

const ja_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのアウトコードを次のイベントのインコードにスナップします`)
};

const hi_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट के आउटकोड को अगले इवेंट के इनकोड से स्नैप करें`)
};

const pt_pt2_shortcut_keys_desc_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronize o código de saída do evento com o código de entrada do próximo evento.`)
};

/**
* | output |
* | --- |
* | "Snap the Event outcode to the next Event's incode" |
*
* @param {Shortcut_Keys_Desc_Chain_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_chain_to_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Chain_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Chain_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_chain_to_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_chain_to_next_event(inputs)
	return en_shortcut_keys_desc_chain_to_next_event(inputs)
});